// infrastructure
import $ from "./lib/qsa.js";
import { Sidechain } from "@civicnews/sidechain";
import { store } from "./state.js";
import { mediaValues, isMobile, isEmbedded } from "./mediaQuery.js";
import "./lib/commandShim.js";

// UI
import { render } from "lit-html";
import "./reactiveUI.js";
import detailTemplate from "./detailTemplate.js";
import "./share-text.js";

// map stuff
import { map, MAX_BOUNDS } from "./map.js";
import { Popup } from "leaflet";
import districtStyle from "./districtStyle.js";
import markerFilter from "./markerFilter.js";
import Wherewolf from "wherewolf";

const EMBEDDED = isEmbedded;
if (EMBEDDED) {
  // we're embedded
  document.body.classList.add("embedded");
  Sidechain.registerGuest();
}

// actual state update responses
let panels = Object.fromEntries([...document.querySelectorAll(".panel")].map(p => [p.id.replace("-panel", ""), p]));

if (!store.raw.districtNumber && !EMBEDDED) panels.intro.showPopover();
let detailContents = panels.detail.querySelector(".contents");
panels.detail.addEventListener("toggle", e => {
  if (e.newState == "closed") {
    map.closePopup();
    if (store.raw.selectedSchool) {
      store.data.selectedSchool = null;
    } else {
      if (!EMBEDDED) store.data.districtNumber = null;
    }
  }
});

$.one("button.clear-selection").addEventListener("click", function() {
  store.data.districtNumber = store.data.selectedSchool = null;
})

store.addEventListener("update", e => {
  map.invalidateSize();
  let { current, records } = e;

  let justChanged = p => current[p] && records.some(r => r[0] == p);
  // when embedded, some changes must come from a user to elicit a reaction
  // this allows us to alter how we respond to state on load (i.e., from URL fragment)
  let userAction = !EMBEDDED || current.userInitiated;

  // zoom to the district?
  if (current.districtNumber && current.districtShapes && userAction) {
    panels.intro.close();
    let layer = current.districtShapes.getLayers().find(l => l.feature.properties.sub == current.districtNumber);
    if (layer) {
      let pad = EMBEDDED ? 40 : 20;
      map.flyToBounds(layer.getBounds(), {
        paddingTopLeft: [pad, mediaValues.paddingTop],
        paddingBottomRight: [pad, pad],
      });
    }
  }

  // zoom back out
  else {
    panels.detail.hidePopover();

    // only do this if the districtNumber changed, otherwise leaflet jitters from an identity flight
    if (current.districtShapes && records.find(r => r[0] == "districtNumber")) {
      map.flyToBounds(current.districtShapes.getBounds(), {
        padding: [20, 20]
      });
    }
  }

  // apply district styles and filters
  current.districtShapes?.setStyle(f => districtStyle(current, f));

  // filter markers
  if (current.profiles) {
    let schools = Object.values(current.profiles);
    let shownMarkers = markerFilter(current, schools);
    for (let school of schools) {
      if (shownMarkers.has(school) && userAction) {
        let isSelected = school == current.selectedSchool;
        school.marker.addTo(map);
        school.marker._icon.classList.toggle("selected", isSelected);
        school.marker.setZIndexOffset(isSelected ? 999 : 0);
      } else {
        school.marker.remove();
      }
    }
  }


  // update the info panel
  if (userAction && (current.selectedSchool || (current.districts && current.districtNumber))) {
    panels.intro.close();
    render(detailTemplate(current), detailContents);
    panels.detail.showPopover();
    if (isMobile.matches) {
      panels.location.hidePopover();
    }
  }

  // if a school is selected, show the popup for it
  if (justChanged("selectedSchool")) {
    let school = current.selectedSchool;
    let marker = school.marker;
    map.openPopup(new Popup(marker.getLatLng(), {
      content: school.short,
      autoPan: false
    }));
    let markerBounds = [marker.getLatLng(), marker.getLatLng()];
    map.flyToBounds(markerBounds, {
      paddingTopLeft: [0, mediaValues.paddingSchool],
      paddingBottomRight: [0, 0]
    });
  }

  if (justChanged("schoolNumber")) {
    panels.location.hidePopover();
  }

  // when the user location is set, open a popup for it
  if (justChanged("userLocation")) {
    if (current.districtShapes?.getBounds().contains(current.userLocation)) {
      panels.location.hidePopover();
      map.openPopup(new Popup(current.userLocation, { content: window.STRINGS["youAreHere"] }));
      if (current.wolf) {
        let result = current.wolf.find({ lat: current.userLocation[0], lng: current.userLocation[1] });
        if (result.district) {
          console.log(result.district.sub);
          store.data.districtNumber = result.district.sub;
        }
      }
    }
  }
});